// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3862":"fc67454a","6005":"c8c4dce3"}[chunkId] + ".chunk.css";
};